/**
 * Server-side VueHub methods in Vue.Functions.Messages.Functions.VueHub
 */
export const ON_CONNECT_METHOD = 'OnUserConnect';
export const ON_DISCONNECT_METHOD = 'OnUserDisconnect';
export const SEND_COMMUNICATION_METHOD = 'SendCommunication';
export const ON_CONNECTION_CLOSE = 'OnConnectionClose';

